import { useMemo } from "react";
import { IRenter } from "../../../../../types/renter.type";
import GenericTable from "../../../../../common/components/ui/table/GenericTable";
import { formatDate } from "../../../../../common/helpers/date.helpers";
import { IVehicleVisualRecord } from "../../../../../types/vehicle-visual-record.type";
import { NavLink } from "react-router-dom";

type Props = {
  data: IRenter;
  renterId: string;
  register: IVehicleVisualRecord[];
};

export function RentalHistory(props: Props) {
  const renterData = props.data.desactivationData?.vehicleHistory;


  const tableHeaders = {
    licensePlate: "Placa",
    startDate: "Data de início",
    returnDate: "Data de devolução/recolhimento",
  };

  const rentalData = useMemo(() => {
    if (!renterData || renterData.length === 0) return [];

    return renterData
      .filter((renterDetails) => renterDetails.licensePlate)
      .map((renterDetails) => {
        return {
          licensePlate: (
            <NavLink
              to={`/veiculos/${renterDetails.licensePlate}`}
              className="text-indigo-600 hover:text-indigo-800"
            >
              {renterDetails.licensePlate || "-"}
            </NavLink>
          ),
          startDate: formatDate(renterDetails.vehicleHistoryInitial),
          returnDate: formatDate(renterDetails.vehicleHistoryEnd),
        };
      })
      .reverse()  
  }, [renterData]);

  return (
    <div>
      {rentalData.length === 0 ? (
        <div>Nenhum veículo registrado no histórico.</div>
      ) : (
        <GenericTable
          headers={tableHeaders}
          data={rentalData as unknown as Record<string, unknown>[]}
        />
      )}
    </div>
  );
}
